<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="8" offset-lg="2">
        <v-card elevation="1">
          <v-card-title>Message Your Office</v-card-title>
          <v-card-text class="mb-2">
            <div class="mb-4">
              <div class="d-block d-sm-flex email mb-2 mb-sm-0">
                <div class="font-weight-medium">From:</div>
                <div class="text-body-2 text-sm-body-1">{{ getUser.email_address }}</div>
              </div>
              <div class="d-block d-sm-flex email">
                <div class="font-weight-medium">To:</div>
                <div class="text-body-2 text-sm-body-1">office+{{ getUser.company_key }}@theinspectorsoffice.com</div>
              </div>
            </div>
            <form @submit.prevent="">
              <v-text-field
                  id="subject"
                  v-model="subject"
                  :error-messages="subjectErrors"
                  filled
                  label="Subject"
                  required
                  @blur="$v.subject.$touch()"
              ></v-text-field>
              <v-textarea
                  id="message"
                  v-model="message"
                  :error-messages="messageErrors"
                  auto-grow
                  filled
                  label="Message"
                  required
                  @blur="$v.message.$touch()"
              ></v-textarea>
              <v-btn
                  :disabled="submitted || $v.$invalid"
                  block
                  class="mr-4"
                  color="primary"
                  @click="submit"
              >
                <v-icon small class="mr-1">mdi-email</v-icon>
                Send
              </v-btn>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import {mapGetters, mapMutations} from 'vuex'
import {displayErrors} from '@/helpers/AppHelper'

export default {
  mixins: [validationMixin],
  name: 'AppMessage',
  validations: {
    subject: {
      required
    },
    message: {
      required
    },
  },
  data() {
    return {
      subject: '',
      message: '',
      submitted: false,
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    subjectErrors() {
      const errors = []
      if (! this.$v.subject.$dirty) return errors
      ! this.$v.subject.required && errors.push('Subject is required.')
      return errors
    },
    messageErrors() {
      const errors = []
      if (! this.$v.message.$dirty) return errors
      ! this.$v.message.required && errors.push('Message is required.')
      return errors
    },
  },
  methods: {
    ...mapMutations(['setShowSnackbar', 'setSnackbarMsg', 'setSnackbarColor']),
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.submitted = true
      this.$axios.post('/api/message', {
        subject: this.subject,
        message: this.message,
      })
          .then(() => {
            this.subject = ''
            this.message = ''
            this.submitted = false
            this.$v.$reset()
            this.setSnackbarColor('success')
            this.setSnackbarMsg('Message sent.')
            this.setShowSnackbar(true)
          })
          .catch(err => {
            displayErrors(err)
            this.submitted = false
          })
    },
  },
}
</script>

<style scoped>
.email div:first-child {
  width: 50px;
}
</style>